<template>
    <v-chip
        :color="superTag ? 'primaryLighter' : 'primary'"
        label
        small
        text-color="white">
        <slot />
    </v-chip>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'table-tag',
    props: {
        superTag: {
            type: Boolean,
            default: false
        }
    }
})
</script>
